import  React from 'react';

import Identities from '../../../elements/Identities'

// TODO(alcore) This should be dynamically pulled from the About page (once/if we centralize state).
const SLACK_INVITE_URL = 'https://join.slack.com/t/gamedevjs/shared_invite/enQtMjY4OTQ5MTQxNDQ1LTkzMzBiYjhhYmJiMGNhOTg1YjJlNzYyNDdiNGVhYzIxNjJhNDIyNWZiYTU3OWYzYzVjZDZlODY2NTJmNGZjOTY';

export default ({person, ...props}) => {
    const identities = [];

    if (person.homepage) identities.push({href: person.homepage, title: 'Homepage', inner: '<i class="icon globe" />'});
    if (person.github) identities.push({href: 'https://github.com/' + person.github, title: 'GitHub: ' + person.github});
    if (person.twitter) identities.push({href: 'https://twitter.com/' + person.twitter, title: 'Twitter: @' + person.twitter});
    if (person.slack) identities.push({href: SLACK_INVITE_URL, title: 'Gamedev.js Slack: ' + person.slack});
    if (person.linkedin) identities.push({href: person.linkedin, title: 'Profil LinkedIn'});

    return <Identities {...props}>{identities}</Identities>
}


// WEBPACK FOOTER //
// ./src/modules/People/elements/PersonIdentities.js